import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { patientNoteQKeys } from "@hooks/queries/patientNote/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { PatientNote } from "@customTypes/patientNote";


interface MutationProps {
  patientNote: Partial<PatientNote>;
  patientId: string;
  appointmentId?: string;
  cId: string;
}

export const useCreatePatientNote = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ patientNote, patientId, appointmentId, cId }: MutationProps) => {
      return api.post("notes/", {
        ...patientNote,
        type: patientNote.category,
        patient_id: patientId,
        appointment_id: appointmentId,
        c_id: cId,
        is_template: patientNote.isTemplate,
      });
    },
    onSuccess: (_, variables) => {
      // console.log("variables:", variables);
      showSuccessNotification({
        title: "success",
        message: "create-patient-note-success",
      });

      queryClient.invalidateQueries(
        patientNoteQKeys.allWithFilters({ patientId: variables.patientId })
      );
      queryClient.invalidateQueries(patientNoteQKeys.tags());
    },

    onError: (res: any) => {
      console.error("[From Create Patient Note]", res);

      handleErrors(res, "mutation");
    },
  });
};
